module.exports = __webpack_public_path__ + "img/LABOUR DAY.b5423b2.svg";